import axios from "axios";
import {  serviceUrls } from "./constant";

import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "./axiosComponent";

//User Management


// export const get = async ({ url, params }) => {
//   return await get({ url, params });
// };

export const getDefaultUserList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/default/user",
    params: createQueryParams(data),
  });
};
export const getUserList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/user/list",
    params: createQueryParams(data),
  });
};
export const addUser = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/organization/user", data: data });
};

export const getUserDetails = async (userId) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/user",
    params: createQueryParams({ entityId: userId }),
  });
};

export const deleteUser = async (entityId) => {
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/organization/user",
    params: createQueryParams({ entityId }),
  });
};

export const updateUser = async (data, entityId) => {
  return await put({
    url: serviceUrls.ADMIN_SERVICE + "/organization/user",
    data,
    params: createQueryParams({ entityId }),
  });
};

export const updateStatus = async (data) => {
  return await patch({
    url: serviceUrls.ADMIN_SERVICE + "/organization/user",
    params: createQueryParams(data),
  });
};

//Group Management
export const getGroupList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/group/list",
    params: createQueryParams(data),
  });
};

export const addGroup = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/organization/group", data: data });
};
export const deleteGroup = async (entityId) => {
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/organization/group",
    params: createQueryParams({ entityId }),
  });
};
export const updateGroup = async (data, entityId) => {
  return await put({
    url: serviceUrls.ADMIN_SERVICE + "/organization/group",
    data,
    params: createQueryParams({ entityId }),
  });
};

export const updateGroupStatus = async (data) => {
  return await patch({
    url: serviceUrls.ADMIN_SERVICE + "/organization/group",
    params: createQueryParams(data),
  });
};

export const getGroupDetails = async (groupId) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/group",
    params: createQueryParams({ entityId: groupId }),
  });
};

//Group User Management
export const getGroupUsersList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/group/user/list",
    params: createQueryParams(data),
  });
};
export const addUserToGroup = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/organization/group/user", data: data });
};
export const deleteGroupUser = async (entityId) => {
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/organization/group/user",
    params: createQueryParams({ entityId }),
  });
};
export const updateGroupUser = async (data) => {
  console.log("updateGroupUser", data);
  return await put({ url: serviceUrls.ADMIN_SERVICE + "/organization/group/user", data: data });
};

//Department Management
export const getDepartmentList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/department/list",
    params: createQueryParams(data),
  });
};

export const addDepartment = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/organization/department", data: data });
};
export const updateDepartmentStatus = async (data) => {
  return await patch({
    url: serviceUrls.ADMIN_SERVICE + "/organization/department",
    params: createQueryParams(data),
  });
};
export const updateDepartment = async (data, entityId) => {
  return await put({
    url: serviceUrls.ADMIN_SERVICE + "/organization/department",
    data,
    params: createQueryParams({ entityId }),
  });
};
export const getDepartmentDetails = async (departmentId) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/department",
    params: createQueryParams({ entityId: departmentId }),
  });
};
export const deleteDepartment = async (entityId) => {
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/organization/department",
    params: createQueryParams({ entityId }),
  });
};

//Department User Management
export const getDepartmentUsersList = async (data) => {
  console.log("getDepartmentUsersList", data);
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/department/user/list",
    params: createQueryParams(data),
  });
};
export const deleteDepartmentUser = async (entityId) => {
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/organization/department/user",
    params: createQueryParams({ entityId }),
  });
};
export const addDepartmentUser = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/organization/department/user", data: data });
};
export const updateDepartmentUser = async (data) => {
  return await put({ url: serviceUrls.ADMIN_SERVICE + "/organization/department/user", data: data });
};

//Role Management
export const getRolesList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/role/list",
    params: createQueryParams(data),
  });
};

export const addRole = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/organization/role", data: data });
};
export const updateRole = async (data) => {
  return await put({
    url: serviceUrls.ADMIN_SERVICE + "/organization/role",
    data,
  });
};
export const updateRoleStatus = async (data) => {
  return await patch({
    url: serviceUrls.ADMIN_SERVICE + "/organization/role",
    params: createQueryParams(data),
  });
};
export const getRoleDetails = async (roleId) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/role",
    params: createQueryParams({ entityId: roleId }),
  });
};

export const deleteRole = async (entityId) => {
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/organization/role",
    params: createQueryParams({ entityId }),
  });
};

export const getRoleUserList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/role/user",
    params: createQueryParams(data),
  });
};
export const addRoleUser = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/organization/role/user", data: data });
};
export const deleteRoleUser = async (entityId) => {
  console.log("deleteRoleUser entityId", entityId);
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/organization/role/user",
    params: createQueryParams({ entityId }),
  });
};

export const getPolicyNameList = async (id) => {
  console.log("ExpandableCard  id is ", id);
  return await get({
    url: serviceUrls.LICENSE_SERVICE + "/default/system/services",
    params: createQueryParams({ entityId: id }),
  });
};

export const getServices = async (id) => {
  console.log(
    "plan id " +
      getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_PLAN"] +
      " organization id " +
      getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"] +
      " id " +
      id
  );
  return await get({
    url: serviceUrls.LICENSE_SERVICE + "/default/organization/plan/services",
    params: createQueryParams({
      entityId: id,
      status: "Y",

      planId: getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_PLAN"],
    }),
  });
};



//FORMS
export const getFormsList = async (data) => {
  console.log("getFormsList", data);
  return await get({
    url: serviceUrls.FORMS_SERVICE + "/list",
    params: createQueryParams(data),
  });
};
export const addForms = async (data) => {
  return await post({ url: serviceUrls.FORMS_SERVICE, data: data });
};
export const updateForms = async (data, entityId) => {
  return await put({
    url: serviceUrls.FORMS_SERVICE,
    data,
    params: createQueryParams({ entityId }),
  });
};
export const deleteForms = async (entityId) => {
  return await del({
    url: serviceUrls.FORMS_SERVICE,
    params: createQueryParams({ entityId }),
  });
};
export const getFormsDetails = async (entityId) => {
  return await get({
    url: serviceUrls.FORMS_SERVICE,
    params: createQueryParams({ entityId }),
  });
};
export const updateFormStatus = async (data) => {
  return await patch({
    url: serviceUrls.FORMS_SERVICE,
    params: createQueryParams(data),
  });
}

export const getFormResponseList = async (data) => {
  return await get({
    url: serviceUrls.FORMS_SERVICE + "/response/list",
    params: createQueryParams(data),
  });
}
export const getFormResponseDetails = async (entityId) => {
  return await get({
    url: serviceUrls.FORMS_SERVICE + "/response",
    params: createQueryParams({ entityId }),
  });
};

export const deleteFormResponse = async (entityId) => {
  return await del({
    url: serviceUrls.FORMS_SERVICE + "/response",
    params: createQueryParams({ entityId }),
  });
}
export const updateFormResponseStatus = async (data) => {
  return await patch({
    url: serviceUrls.FORMS_SERVICE + "/response",
    params: createQueryParams(data),
  });
}
export const submitFormResponse = async (data) => {
  return await post({
    url: serviceUrls.FORMS_SERVICE + "/response",
    data: data,
  });
}


//Examination
export const getExamainationTemplatesList = async (data) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/list",
    params: createQueryParams(data),
  });
}

export const addExaminationTemplate = async (data) => {
  return await post({ url: serviceUrls.EXAMINATION_SERVICE + "/template", data: data });
};
export const updateExaminationTemplate = async (entityId, data) => {
  return await put({
    url: serviceUrls.EXAMINATION_SERVICE + "/template",
    data,
    params: createQueryParams({ entityId }),
  });
};
export const deleteExaminationTemplate = async (entityId) => {
  return await del({
    url: serviceUrls.EXAMINATION_SERVICE + "/template",
    params: createQueryParams({ entityId }),
  });
}
export const getExaminationTemplateDetails = async (entityId) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/template",
    params: createQueryParams({ entityId }),
  });
};
export const updateExaminationTemplateStatus = async (data) => {
  return await patch({
    url: serviceUrls.EXAMINATION_SERVICE + "/template",
    params: createQueryParams(data),
  });
}
;


export const addTemplateSection = async (data) => {
  return await post({ url: serviceUrls.EXAMINATION_SERVICE + "/template/section", data: data });
};
export const getTemplateSectionList = async (data) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/section/list",
    params: createQueryParams(data),
  });
}
export const updateTemplateSection = async (data, entityId) => {
  return await put({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/section",
    data,
    params: createQueryParams({ entityId }),
  });
};
export const deleteTemplateSection = async (entityId) => {
  return await del({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/section",
    params: createQueryParams({ entityId }),
  });
}
export const getTemplateSectionDetails = async (entityId) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/section",
    params: createQueryParams({ entityId }),
  });
};

export const getQuestionList = async (data) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/question/list",
    params: createQueryParams(data),
  });
}
export const addQuestion = async (data) => {
  delete data.id
  return await post({ url: serviceUrls.EXAMINATION_SERVICE + "/template/question", data: data });
};
export const updateQuestion = async (data, entityId) => {
  return await put({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/question",
    data,
    params: createQueryParams({ entityId }),
  });
}
export const deleteQuestion = async (entityId) => {
  return await del({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/question",
    params: createQueryParams({ entityId }),
  });
}
export const getQuestionDetails = async (entityId) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/question",
    params: createQueryParams({ entityId }),
  });
}
export const updateQuestionStatus = async (data) => {
  return await patch({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/question",
    params: createQueryParams(data),
  });
}


//Examination template share

export const getExaminationTemplateShareList = async (data) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/share/list",
    params: createQueryParams(data),
  });
}
export const addExaminationTemplateShare = async (data) => {
  return await post({ url: serviceUrls.EXAMINATION_SERVICE + "/template/share", data: data });
};  
export const updateExaminationTemplateShare = async (data, entityId) => {
  return await put({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/share",
    data,
    params: createQueryParams({ entityId }),
  });
};
export const deleteExaminationTemplateShare = async (entityId) => {
  return await del({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/share",
    params: createQueryParams({ entityId }),
  });
}
export const getExaminationTemplateShareDetails = async (entityId) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/share",
    params: createQueryParams({ entityId }),
  });
}
export const updateExaminationTemplateShareStatus = async (data) => {
  return await patch({
    url: serviceUrls.EXAMINATION_SERVICE + "/template/share",
    params: createQueryParams(data),
  });
}




//Examination Series
export const getExaminationSeriesList = async (data) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/series/list",
    params: createQueryParams(data),
  });
}
export const addExaminationSeries = async (data) => {
  return await post({ url: serviceUrls.EXAMINATION_SERVICE + "/series", data: data });
};
export const updateExaminationSeries = async (data, entityId) => {
  return await put({
    url: serviceUrls.EXAMINATION_SERVICE + "/series",
    data,
    params: createQueryParams({ entityId }),
  });
}
export const deleteExaminationSeries = async (entityId) => {
  return await del({
    url: serviceUrls.EXAMINATION_SERVICE + "/series",
    params: createQueryParams({ entityId }),
  });
}
export const getExaminationSeriesDetails = async (entityId) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/series",
    params: createQueryParams({ entityId }),
  });
}
export const updateExaminationSeriesStatus = async (data) => {
  return await patch({
    url: serviceUrls.EXAMINATION_SERVICE + "/series",
    params: createQueryParams(data),
  });
} 



//Approving
export const getApproversList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/approval/request/approvers/list",
    params: createQueryParams(data),
  });
}
export const addApprovers = async (data) => {
  return await post({
    url: serviceUrls.ADMIN_SERVICE + "/approval/request/approvers",
    data: data,
  });
}
export const updateApprovers = async (data, entityId) => {
  return await put({
    url: serviceUrls.ADMIN_SERVICE + "/approval/request/approvers",
    data,
    params: createQueryParams({ entityId }),
  });
}
export const deleteApprovers = async (entityId) => {
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/approval/request/approvers",
    params: createQueryParams({ entityId }),
  });
}
export const getApproversDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/approval/request/approvers",
    params: createQueryParams({ entityId }),
  });
}
export const updateApproversStatus = async (data) => {
  return await patch({
    url: serviceUrls.ADMIN_SERVICE + "/approval/request/approvers",
    params: createQueryParams(data),
  });
}



//Approving Request
export const getApprovalRequestList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/approval/request/list",
    params: createQueryParams(data),
  });
}
export const getApprovalRequestDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/approval/request",
    params: createQueryParams({ entityId }),
  });
}
export const addApprovalRequest = async (data) => {
  return await post({
    url: serviceUrls.ADMIN_SERVICE + "/approval/request",
    data: data,
  });
}
export const updateApprovalRequest = async (data, entityId) => {
  return await put({
    url: serviceUrls.ADMIN_SERVICE + "/approval/request",
    data,
    params: createQueryParams({ entityId }),
  });
}


//series subject
export const getExaminationSeriesSubjectList = async (data) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/series/subject/list",
    params: createQueryParams(data),
  });
}
export const addExaminationSeriesSubject = async (data) => {
  return await post({ url: serviceUrls.EXAMINATION_SERVICE + "/series/subject", data: data });
}
export const updateExaminationSeriesSubject = async (data, entityId) => {
  return await put({
    url: serviceUrls.EXAMINATION_SERVICE + "/series/subject",
    data,
    params: createQueryParams({ entityId }),
  });
}
export const deleteExaminationSeriesSubject = async (entityId) => {
  return await del({
    url: serviceUrls.EXAMINATION_SERVICE + "/series/subject",
    params: createQueryParams({ entityId }),
  });
}

export const getExaminationSeriesSubjectDetails = async (entityId) => {
  return await get({
    url: serviceUrls.EXAMINATION_SERVICE + "/series/subject",
    params: createQueryParams({ entityId }),
  });
}

//Examination LIST

